// @ts-nocheck
import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import Leagues from '../pages/Leagues/Leagues'
import Rewards from '../pages/Rewards/Rewards'
import Contact from '../pages/Contact/Contact'
import Affiliate from '../pages/Affiliate/Affiliate'
import PrivacyPolicy from '../pages/Settings/PrivacyPolicy'
import FAQ from '../pages/Settings/FAQ'
import TermsandCondition from '../pages/Settings/TermsandCondition'
import Branding from '../pages/Settings/Branding'
import ListingOrder from '../pages/ListingOrder/ListingOrder'
import ProfilePhotos from '../pages/ProfilePhotos/ProfilePhotos'
import Specials from '../pages/Specials/Specials'
import PushNotifications from '../pages/PushNotifications/PushNotifications'
import Reviews from '../pages/Reviews/Reviews'
import FlaggedContent from '../pages/FlaggedContent/FlaggedContent'
import Faqs from '../pages/Faqs/Faqs'
import AiUsage from '../pages/AiUsage/AiUsage'
import PractitionerAnalytics from '../pages/Analytics/PractitionerAnalytics'
import Referrals from '../pages/Referrals/Referrals'
import EditText from '../pages/EditText/EditText'
import Categories from '../pages/Categories/Categories'
import Videos from '../pages/Videos/Videos'
import Passes from '../pages/Passes/Passes'
import UsersManagement from '../pages/Users/UsersManagement'
import PremiumRequests from '../pages/Premiums/PremiumRequests'
import ClassesManagement from '../pages/Classes/ClassesManagement'
import BookingsManagement from '../pages/Bookings/BookingsManagement'
import TransactionsManagement from '../pages/Transactions/TransactIonManagement'
import ClientsManagement from '../pages/clients-management/UsersManagement'
import CreateNewReward from '../pages/Rewards/reward-points/reward-points-list/components/CreateNewReward'
import RewardDetails from '../pages/Rewards/reward-points/reward-points-list/components/RewardDetails'
import EditRewards from '../pages/Rewards/reward-points/reward-points-list/components/EditRewards'
import EditAffiliate from '../pages/Affiliate/create-affiliate/affiliate-list-details/EditAffiliate'

import AccountPage from '../modules/accounts/AccountPage'
import SubAdminRoutes from '../pages/SubAdmins/SubAdminDetails/SubAdminRoutes'
import ReportsDetailsViewPage from '../pages/Reports/reports-details-page/ReportsDetailsViewPage'
import ReportsRoutes from '../pages/Reports/ReportsRoutes'

import WidgetsPage from '../modules/widgets/WidgetsPage'
import ChatPage from '../modules/apps/chat/ChatPage'
import UsersPage from '../modules/apps/user-management/UsersPage'

import BookingFees from '../pages/BookingFees/BookingFees'
import CreateNewBookingFee from '../pages/BookingFees/CreateNewBookingFee'
import EditClasses from '../pages/Classes/EditClasses'

const PrivateRoutes = () => {
  //Booking Fees
  const BookingFeesRoutes = lazy(() => import('../pages/BookingFees/BookingFeeRoutes'))

  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  // const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  // const SubAdminRoutes = lazy(() => import('../pages/SubAdmins/SubAdminDetails/SubAdminRoutes'))
  const UsersDetailsRoutes = lazy(() => import('../pages/Users/UserDetailsRoutes'))
  const BookingDetailsRoutes = lazy(() => import('../pages/Bookings/UserDetailsRoutes'))
  const TransactionDetailsRoutes = lazy(() => import('../pages/Transactions/UserDetailsRoutes'))
  const ClassesDetailsRoutes = lazy(() => import('../pages/Classes/UserDetailsRoutes'))
  const ClassesEditRoutes = lazy(() => import('../pages/Classes/EditClasses'))
  const ClientDetailsRoutes = lazy(() => import('../pages/clients-management/UserDetailsRoutes'))

  // const ServicesPage = lazy(() => import('../pages/services-management/ServicesPage'))

  /* Notification Page */
  const NotificationPage = lazy(() => import('../pages/notification-management/NotificationPage'))

  /* End  */

  const ReportsPage = lazy(() => import('../pages/Reports/ReportsRoutes'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />

        {/* Routes for new pages begin */}
        {/* <Route path='all-users' element={<Users />} /> */}

        {/* <Route
          path='apps/affiliate-management/affiliate-list/details-page/:id/*'
          element={
            <SuspensedView>
              <AffiliateListDetailsRoutes />
            </SuspensedView>
          }
        ></Route> */}
        {/* Affiliate management begins */}
        {/* <Route
          path='apps/affiliate-management/affiliate-list/create-affiliate'
          element={
            <SuspensedView>
              <CreateAffiliateForm />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='apps/affiliate-management/affiliate-list/:id/edit'
          element={
            <SuspensedView>
              <EditAffiliate />
            </SuspensedView>
          }
        ></Route>

        <Route
          path='apps/affiliate-management/*'
          element={
            <SuspensedView>
              <AffiliateListRoutes />
              <AffiliateRegisterationRoutes />
            </SuspensedView>
          }
        ></Route> */}
        {/* Affiliate management ends */}

        {/* <Route path='affiliate' element={<Affiliate />} /> */}
        <Route path='contact' element={<Contact />} />

        <Route path='settings/terms-and-condition' element={<TermsandCondition />} />
        <Route path='settings/privacy-policy' element={<PrivacyPolicy />} />
        <Route path='settings/faq' element={<FAQ />} />
        <Route path='settings/branding' element={<Branding />} />
        <Route path='listing-order' element={<ListingOrder />} />
        <Route path='profile-photos' element={<ProfilePhotos />} />
        <Route path='specials' element={<Specials />} />
        <Route path='push-notifications' element={<PushNotifications />} />
        <Route path='reviews' element={<Reviews />} />
        <Route path='flagged-content' element={<FlaggedContent />} />
        <Route path='faqs' element={<Faqs />} />
        <Route path='ai-usage' element={<AiUsage />} />
        <Route path='practitioner-analytics' element={<PractitionerAnalytics />} />
        <Route path='referrals' element={<Referrals />} />
        <Route path='edit-text' element={<EditText />} />
        <Route path='categories' element={<Categories />} />
        <Route path='meditations' element={<Videos />} />
        <Route path='packs-memberships' element={<Passes />} />

        {/* Routes for new pages end */}

        {/* Sub Admin Details Page Begin */}
        <Route
          path='apps/user-management/users/details-page/:*'
          element={
            <SuspensedView>
              <SubAdminRoutes />
            </SuspensedView>
          }
        />

        {/* Booking Fees */}

        <Route path='booking-fees' element={<BookingFees />} />

        <Route
          path='apps/booking-fees-management/*'
          element={
            <SuspensedView>
              <BookingFeesRoutes />
            </SuspensedView>
          }
        />
        <Route
          path='apps/booking-fees-management/booking-fees/new-fee'
          element={
            <SuspensedView>
              <CreateNewBookingFee />
            </SuspensedView>
          }
        />

        {/* Sub Admin Details Page End */}

        {/* Reports Page */}

        <Route
          path='/apps/reports-management/*'
          element={
            <SuspensedView>
              <ReportsPage />
            </SuspensedView>
          }
        />

        {/* Services Details Page Begin */}
        {/* <Route
          path='apps/services-management/services/details-page/:id/*'
          element={
            <SuspensedView>
              <ServicesRoutes />
            </SuspensedView>
          }
        /> */}
        {/* Services Details Page End */}

        {/* Sub Admin table Route begins */}
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        {/* Sub Admin table Route ends */}

        {/* Services table Route begins */}
        {/* <Route
          path='apps/services-management/*'
          element={
            <SuspensedView>
              <ServicesPage />
            </SuspensedView>
          }
        /> */}
        {/* Services table Route ends */}

        {/* Notification Page */}
        <Route
          path='apps/notification-management/*'
          element={
            <SuspensedView>
              <NotificationPage />
            </SuspensedView>
          }
        />
        {/* Notification Page End*/}

        {/* All Clients Details page Routes begin */}
        <Route
          path='apps/clients/details-page/:id/*'
          element={
            <SuspensedView>
              <ClientDetailsRoutes />
            </SuspensedView>
          }
        />
        {/* All Clients Details page Routes end  */}

        {/* All Clients table begin */}
        <Route
          path='apps/clients/*'
          element={
            <SuspensedView>
              <ClientsManagement />
            </SuspensedView>
          }
        />
        {/* All Clients table end */}

        {/* All Agents Details page Routes begin */}
        <Route
          path='apps/agents/details-page/:id/*'
          element={
            <SuspensedView>
              <UsersDetailsRoutes />
            </SuspensedView>
          }
        />
        {/* All Agents Details page Routes end  */}

        {/* All Agents table begin */}
        <Route
          path='apps/agents/*'
          element={
            <SuspensedView>
              <UsersManagement />
            </SuspensedView>
          }
        />

        {/* All Agents table end */}

        {/* Premium Requests */}

        <Route
          path='apps/premium-requests/*'
          element={
            <SuspensedView>
              <PremiumRequests />
            </SuspensedView>
          }
        />

        {/* All Agents table begin */}
        <Route
          path='apps/classes/*'
          element={
            <SuspensedView>
              <ClassesManagement />
            </SuspensedView>
          }
        />
        <Route
          path='apps/classes/details-page/:id/*'
          element={
            <SuspensedView>
              <ClassesDetailsRoutes />
            </SuspensedView>
          }
        />
        <Route
          path='apps/classes/edit/:id/*'
          element={
            <SuspensedView>
              <ClassesEditRoutes />
            </SuspensedView>
          }
        />
        {/* All Agents table end */}

        {/* All Agents table begin */}
        <Route
          path='apps/bookings/*'
          element={
            <SuspensedView>
              <BookingsManagement />
            </SuspensedView>
          }
        />

        <Route
          path='apps/bookings/details-page/:id/*'
          element={
            <SuspensedView>
              <BookingDetailsRoutes />
            </SuspensedView>
          }
        />
        {/* All Agents table end */}

        {/* All Agents table begin */}
        <Route
          path='apps/transactions/*'
          element={
            <SuspensedView>
              <TransactionsManagement />
            </SuspensedView>
          }
        />

        <Route
          path='apps/transactions/details-page/:id/*'
          element={
            <SuspensedView>
              <TransactionDetailsRoutes />
            </SuspensedView>
          }
        />
        {/* All Agents table end */}

        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='/pps/reports-management/reports/*'
          element={
            <SuspensedView>
              <ReportsRoutes />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
